"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientMode = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../app");
const contract_print_1 = require("../components/contract/contract_print");
const client_dashboard_1 = require("../components/dashboard/client_dashboard");
const invoice_print_1 = require("../components/invoice/invoice_print");
const main_1 = require("../main");
const nav_1 = require("../nav");
const booking_calendar_page_1 = require("../pages/booking_calendar_page");
const change_password_page_1 = require("../pages/change_password_page");
const client_account_page_1 = require("../pages/client_account_page");
const client_audit_page_1 = require("../pages/client_audit_page");
const client_booking_page_1 = require("../pages/client_booking_page");
const client_contracts_page_1 = require("../pages/client_contracts_page");
const client_payments_index_page_1 = require("../pages/client_payments_index_page");
const contact_us_page_1 = require("../pages/contact_us_page");
const forgot_password_page_1 = require("../pages/forgot_password_page");
const sign_in_1 = require("../pages/sign_in");
exports.ClientMode = {
    routes: {
        "/sign-in": sign_in_1.SignIn,
        "/forgot-password": forgot_password_page_1.ForgotPasswordPage,
        "/reset-password/:email/:token": change_password_page_1.ChangePasswordPage,
        "/&:opts...": (0, main_1.MainLayout)(client_dashboard_1.ClientDashboard),
        "/calendar/bookings&:opts...": (0, main_1.MainLayout)(booking_calendar_page_1.BookingCalendarPage),
        "/me/bookings&:opts...": (0, main_1.MainLayout)(client_booking_page_1.ClientBookingPage),
        "/me/contracts&:opts...": (0, main_1.MainLayout)(client_contracts_page_1.ClientContractsPage),
        "/me/payments&:opts...": (0, main_1.MainLayout)(client_payments_index_page_1.ClientPaymentsIndexPage),
        "/contracts/:contract_id/print": contract_print_1.ContractPrint,
        "/invoices/:invoice_id/print": invoice_print_1.InvoicePrint,
        "/me/account&:opts...": (0, main_1.MainLayout)(client_account_page_1.ClientAccountPage),
        "/audit&:opts...": (0, main_1.MainLayout)(client_audit_page_1.ClientAuditPage),
        "/contact-us&:opts...": (0, main_1.MainLayout)(contact_us_page_1.ContactUsPage),
    },
    nav() {
        return (0, mithril_1.default)("aside.menu", (0, mithril_1.default)("hr"), (0, mithril_1.default)("ul.menu-list", (0, mithril_1.default)("p.menu-label", ""), (0, mithril_1.default)((0, nav_1.ni)("#/&", "Tableau de bord", "fa-chart-bar")), (0, mithril_1.default)((0, nav_1.ni)("#/calendar/bookings&", (0, mithril_1.default)("strong", "Réserver"), "fa-calendar-alt")), (0, mithril_1.default)("p.menu-label", "Paramètres"), (0, mithril_1.default)((0, nav_1.ni)("#/me/bookings&", "Mes réservations", "fa-calendar-alt")), (0, mithril_1.default)((0, nav_1.ni)("#/me/contracts&", "Mes forfaits", "fa-file-contract")), (0, mithril_1.default)((0, nav_1.ni)("#/me/payments&", "Mes paiements", "fa-money-check-alt")), (0, mithril_1.default)((0, nav_1.ni)("#/audit&", "Historique", "fa-clock")), (0, mithril_1.default)((0, nav_1.ni)("#/me/account&", "Mon compte", "fa-cog")), (0, mithril_1.default)("hr"), (0, mithril_1.default)((0, nav_1.ni)("#/contact-us&", "Nous contacter", "fa-paper-plane")), (0, mithril_1.default)((0, nav_1.navItem)({
            route: app_1.App.getSettings("new_contract_request_link"),
            title: "Renouveler mon forfait",
            icon: "fa-check-square",
            attrs: { target: "_blank" }
        }))));
    }
};
